module.exports = __webpack_public_path__ + "img/icon-alert.35339a04.svg";